// extracted by mini-css-extract-plugin
export var actionText = "_od-4";
export var container = "_od-0";
export var leftSection = "_od-1";
export var rightSection = "_od-2";
export var settingsButton = "_od-6";
export var settingsIcon = "_od-7";
export var shortcut = "_od-5";
export var shortcutGroup = "_od-3";